import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useUser } from "../contexts/UserContext";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

const Register = () => {
  const { register } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.redirect || "/";
  const [form, setForm] = useState({ nombre: "", correo: "", password: "", telefono: "", direccion: "", rut: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre || !form.correo || !form.password) {
      toast.error("Completa los campos requeridos"); return;
    }
    if (form.password.length < 6) { toast.error("La contraseña debe tener al menos 6 caracteres"); return; }
    setLoading(true);
    try {
      await register(form);
      toast.success("¡Cuenta creada! 🎉");
      navigate(redirect);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al registrar");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="min-h-screen flex items-center justify-center bg-cream px-6 py-12">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo size="large" /></div>
        <div className="bg-white border-2 border-black p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="h-10 w-10 bg-mint border-2 border-black flex items-center justify-center">
              <UserPlus className="h-4 w-4 text-black" />
            </div>
            <div>
              <h1 className="font-heading text-2xl font-bold text-brand-ink">Crear cuenta</h1>
              <p className="text-xs text-gray-500">Promociones y novedades primero 💌</p>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <Field label="Nombre y apellido *" value={form.nombre} onChange={(v) => setForm({...form, nombre: v})} testid="register-nombre" />
            <Field label="Correo *" type="email" value={form.correo} onChange={(v) => setForm({...form, correo: v})} testid="register-correo" />
            <Field label="Contraseña * (mín 6)" type="password" value={form.password} onChange={(v) => setForm({...form, password: v})} testid="register-password" />
            <Field label="Teléfono" value={form.telefono} onChange={(v) => setForm({...form, telefono: v})} testid="register-telefono" required={false} />
            <Field label="RUT" value={form.rut} onChange={(v) => setForm({...form, rut: v})} testid="register-rut" required={false} />
            <Field label="Dirección" value={form.direccion} onChange={(v) => setForm({...form, direccion: v})} testid="register-direccion" required={false} />
            <button type="submit" disabled={loading} data-testid="register-submit" className="btn-chunky w-full bg-yolk text-black py-3.5 text-sm">
              {loading ? "Creando..." : "CREAR MI CUENTA"}
            </button>
          </form>
          <p className="text-center text-sm text-gray-600 mt-6">
            ¿Ya tienes cuenta? <Link to="/login" data-testid="register-go-login" className="text-mint-deep font-bold link-underline">Ingresar</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, type = "text", value, onChange, testid, required = true }) => (
  <div>
    <label className="block text-xs uppercase tracking-[0.2em] font-bold text-brand-ink mb-2">{label}</label>
    <input type={type} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} required={required} className="w-full border-2 border-black px-4 py-3 text-sm focus:outline-none focus:border-mint-deep" />
  </div>
);

export default Register;
